/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeV2 } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- DIMENSIONS FORM : STYLES --------------- ++++++++++ */
export default theme => ({
    formatSettings:{
        '& .name-format': {
            display: 'flex'
        },
        '& .sectiongroup': {
            '& .group':{
                '& .control': {
                    marginRight: pxToEm(15),
                    paddingTop: pxToEm(0),
                    borderRadius: pxToEm(12),
                    border: '2px solid #061240'
                },
                '& .selected-true': {
                    border: '3px solid #3257EC',
                    background: '#E7EAF7',
                    '& .checkmark':{
                        '& span':{
                            '& i':{
                                color: '#3257EC',
                            }
                        }

                    }
                }
            }
        }
    }
});
